'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useParams } from 'next/navigation';
import { captureCalculatorError } from '@/utils/sentryCalculator';

export default function CalculatorError({ error, reset }) {
  const params = useParams();
  const insuranceSlug = params?.insurance;

  useEffect(() => {
    captureCalculatorError(error, {
      component: 'CalculatorErrorBoundary',
      extra: { insurance_slug: insuranceSlug },
    });
    Sentry.setTag('insurance_slug', insuranceSlug || 'unknown');
  }, [error, insuranceSlug]);

  return (
    <div
      style={{
        maxWidth: 560,
        margin: '4rem auto',
        padding: '0 1.5rem',
        textAlign: 'center',
        fontFamily: 'var(--font-dm-sans, sans-serif)',
      }}
    >
      <h2 style={{ marginBottom: '0.75rem' }}>Įvyko klaida</h2>
      <p style={{ color: '#555', marginBottom: '1.5rem' }}>
        Skaičiuoklėje įvyko nenumatyta klaida. Bandykite dar kartą arba
        grįžkite vėliau.
      </p>
      <button
        type='button'
        onClick={() => reset()}
        style={{
          padding: '0.65rem 1.25rem',
          borderRadius: 8,
          border: 'none',
          background: '#1a1a2e',
          color: '#fff',
          cursor: 'pointer',
        }}
      >
        Bandyti dar kartą
      </button>
    </div>
  );
}
